/**
 * Created by dimah on 30/08/17.
 */
import { AbstractDTO } from "./abstract";

export class RegistrationDTO extends AbstractDTO {
    user_phone: string;
    first_name: string;
    last_name: string;
    username: string;
    user_email: string;
    password: string;
    confirmPassword: string;

    constructor(attributes?: Object) {
        attributes = attributes ? attributes : {};
        super(attributes);

        this.user_phone = attributes['user_phone'] || "";
        this.first_name = attributes['first_name'] || "";
        this.last_name = attributes['last_name'] || "";
        this.username = attributes['username'] || "";
        this.user_email = attributes['user_email'] || "";
        this.password = attributes['password'] || "";
        this.confirmPassword = attributes['confirmPassword'] || "";
    }
}